import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import Button from 'components/Buttons/Button';
import { ColorPicker } from 'xland-ui';

function PopupColors(props) {
  const {
    literals,
    colors: platformColors,
    onSubmit,
    onClose,
  } = props;

  const [loading, setLoading] = useState(false);
  const [colors, setColors] = useState({
    'content-highest': { name: literals.colors.contentHighest, value: platformColors['content-highest'] },
    'content-high': { name: literals.colors.contentHigh, value: platformColors['content-high'] },
    'content-mid': { name: literals.colors.contentMid, value: platformColors['content-mid'] },
    'content-low': { name: literals.colors.contentLow, value: platformColors['content-low'] },
    'content-low-alt': { name: literals.colors.contentLowAlt, value: platformColors['content-low-alt'] },
    'content-lowest': { name: literals.colors.contentLowest, value: platformColors['content-lowest'] },
    'content-lowest-alt': { name: literals.colors.contentLowestAlt, value: platformColors['content-lowest-alt'] },
    'content-link': { name: literals.colors.contentLink, value: platformColors['content-link'] },
    'bg-high': { name: literals.colors.bgHigh, value: platformColors['bg-high'] },
    'bg-low': { name: literals.colors.bgLow, value: platformColors['bg-low'] },
    'bg-none': { name: literals.colors.bgNone, value: platformColors['bg-none'] },
    'semantic-danger-high': { name: literals.colors.semanticDangerHigh, value: platformColors['semantic-danger-high'] },
    'semantic-danger-low': { name: literals.colors.semanticDangerLow, value: platformColors['semantic-danger-low'] },
    'semantic-success-high': { name: literals.colors.semanticSuccessHigh, value: platformColors['semantic-success-high'] },
    'semantic-success-low': { name: literals.colors.semanticSuccessLow, value: platformColors['semantic-success-low'] },
    'semantic-warning-high': { name: literals.colors.semanticWarningHigh, value: platformColors['semantic-warning-high'] },
    'semantic-warning-low': { name: literals.colors.semanticWarningLow, value: platformColors['semantic-warning-low'] },
    'semantic-caution-high': { name: literals.colors.semanticCautionHigh, value: platformColors['semantic-caution-high'] },
    'semantic-caution-low': { name: literals.colors.semanticCautionLow, value: platformColors['semantic-caution-low'] },
    'extended-01-high': { name: literals.colors.extended01High, value: platformColors['extended-01-high'] },
    'extended-01-low': { name: literals.colors.extended01Low, value: platformColors['extended-01-low'] },
    'extended-02-high': { name: literals.colors.extended02High, value: platformColors['extended-02-high'] },
    'extended-02-low': { name: literals.colors.extended02Low, value: platformColors['extended-02-low'] },
    'extended-03-high': { name: literals.colors.extended03High, value: platformColors['extended-03-high'] },
    'extended-03-low': { name: literals.colors.extended03Low, value: platformColors['extended-03-low'] },
    'extended-04-high': { name: literals.colors.extended04High, value: platformColors['extended-04-high'] },
    'extended-04-low': { name: literals.colors.extended04Low, value: platformColors['extended-04-low'] },
  });

  const handleChangeColor = (key, value) => {
    setColors(prev => ({ ...prev, [key]: { ...prev[key], value } }));
  };

  return (
    <Popup title={literals.colors.title} onClose={onClose} size='sm'>
      {Object.entries(colors).map(([key, color]) => (
        <div className='d-flex align-items-center justify-content-between'>
          <span>{color.name}</span>
          <ColorPicker
            className='ms-5'
            color={color.value}
            onColorChange={value => handleChangeColor(key, value)}
          />
        </div>
      ))}
      <div className='buttons mt-3'>
        <Button
          text={literals.send}
          onClick={() => {
            setLoading(true);
            const auxColors = {};
            Object.entries(colors).forEach(([key, color]) => {
              if (color.value) {
                auxColors[key] = color.value;
              }
            });
            onSubmit(auxColors);
          }}
          loading={loading}
        />
      </div>
    </Popup>
  );
}

PopupColors.propTypes = {
  literals: PropTypes.object.isRequired,
  colors: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PopupColors;
